import type { WorkspaceTab } from './workspaceTabs';

export type DockPane = { side: 'right' | 'bottom'; size: number; tabs: WorkspaceTab[]; activeTabId: string; frameEntityId: string };

export function addDockTab(current: DockPane | null, tab: WorkspaceTab, side: DockPane['side'], limit: number): DockPane | null {
  if (!tab.entityId) return current;
  const dock = current?.side === side ? current : { side, size: .48, tabs: [], activeTabId: tab.id, frameEntityId: tab.entityId };
  const tabs = dock.tabs.some((item) => item.id === tab.id) ? [...dock.tabs] : [...dock.tabs, { ...tab, groupId: null, pinned: false, order: dock.tabs.length }];
  const oldest = [...tabs].sort((a, b) => a.createdAt - b.createdAt);
  while (tabs.length > limit && oldest.length) {
    const remove = oldest.shift()!;
    tabs.splice(tabs.findIndex((item) => item.id === remove.id), 1);
  }
  return { ...dock, tabs, activeTabId: tab.id };
}

export function removeDockTab(current: DockPane | null, id: string): DockPane | null {
  if (!current) return null;
  const index = current.tabs.findIndex((tab) => tab.id === id);
  const tabs = current.tabs.filter((tab) => tab.id !== id);
  if (!tabs.length) return null;
  const activeTabId = current.activeTabId === id ? tabs[index]?.id ?? tabs[index - 1]?.id ?? tabs[0]!.id : current.activeTabId;
  return { ...current, tabs, activeTabId };
}
